<script>
import {ref} from "vue";
import useTools from "@/use/Tools";
import useValidation from "@/use/Validation";
import axios from "axios";
import ImportModel from "@/views/Tools/Components/ImportModel.vue";
import {useSecurityStore} from "@/stores/Security";
import useSharedSelectData from "@/use/SharedSelectData";

export default {
    components: {ImportModel},
    setup() {
        const {mxRules} = useValidation();
        const {$swal, $i18n} = useTools();
        const securityStore = useSecurityStore();
        const {evaluationFileTypes} = useSharedSelectData();
        
        const dialog = ref(false);
        const loading = ref(false);
        const file = ref(null);
        const type = ref('EVALUATION_PERFORMANCE');
        const evaluationMeasures = ref([]);
        const search = ref(null);
        
        const headers = [
            {
                text: $i18n.t('common.label'),
                value: 'name',
                width: "0%"
            },
            {
                text: $i18n.t('common.comment'),
                value: 'notes'
            },
        ];
        
        
        function upload() {
            loading.value = true;
            let formData = new FormData();
            formData.append('file', file.value);
            axios.post(`/tools/getEvaluationMeasures`, formData, {
                params: {
                    type: type.value,
                }
            }).then(response => {
                evaluationMeasures.value = response.data.elements;
                dialog.value = false;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function apply() {
            loading.value = true;
            axios.post(`/evaluationMeasures/saveAll`, evaluationMeasures.value).then(() => {
                $swal.fire('Très Bien', "Importation des critère terminer", 'success')
                evaluationMeasures.value = [];
            }).finally(() => {
                loading.value = false;
            });
        }
        
        return {
            securityStore,
            mxRules,
            dialog,
            loading,
            headers,
            file,
            type,
            search,
            evaluationFileTypes,
            evaluationMeasures,
            apply,
            upload,
        }
    }
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.evaluation_measures_tools')"
            show-total
            :total="evaluationMeasures.length"
        >
            <template v-slot:leftToolbar>
                <ImportModel file-name="Fonction.xlsx"/>
            </template>
            <template v-slot:rightToolbar>
                <w-btn
                    color="teal"
                    icon="mdi-import"
                    :text="$t('common.import')"
                    @press="dialog = true"
                />
                <w-btn
                    v-if="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                    color="red"
                    icon="mdi-table-check"
                    :text="$t('common.apply')"
                    :loading="loading"
                    @press="apply"
                />
            
            </template>
            
            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field v-model="search" :label="$t('common.search')"/>
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :search="search"
                    :items="evaluationMeasures"
                    :loading="loading"
                    identity="name"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text
                            bold
                            :text="item.name"
                            :length="80"
                        />
                    </template>
                    <template v-slot:[`item.notes`]="{ item }">
                        <w-inline-text
                            :text="item.notes"
                            :length="80"
                        />
                    </template>
                </w-data-table>
            
            </template>
        </w-app>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="700"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.import')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('common.file')" required/>
                                <w-file-input
                                    v-model="file"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.type')" required/>
                                <w-enum-select
                                    v-model="type"
                                    :items="evaluationFileTypes"
                                    not-clearable
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn-import
                        :loading="loading"
                        @press="upload"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>